import { motion } from "framer-motion";

const STEPS = [
  { t: "Evaluare teren", d: "Discutăm la telefon și stabilim împreună locul optim pentru puț." },
  { t: "Calibrarea utilajului", d: "Aducem utilajul de foraj și pregătim platforma de lucru." },
  { t: "Forarea propriu-zisă", d: "Forăm la adâncimea necesară, până prindem pânza de apă." },
  { t: "Tubare cu PVC albastru cu filet", d: "Însurubăm etanș segmentele de țeavă albastră, segment cu segment." },
  { t: "Filtrul de pietriș", d: "Montăm filtrul și pietrișul mărgăritar la baza puțului." },
  { t: "Denisipare și pompaj de limpezire", d: "Curățăm forajul până iese apa limpede, fără nisip." },
  { t: "Predare și test de debit", d: "Testăm debitul și predăm puțul gata de folosire." },
];

export default function ProcessSection() {
  return (
    <section id="proces" className="scroll-mt-16 bg-hydro-navy py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-cyan sm:text-xs">
            Proces
          </p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl md:text-6xl">
            De la telefon la apă în curte.
          </h2>
        </motion.div>

        <ol className="relative mt-14 max-w-3xl space-y-9 border-l border-white/10 ml-3 md:ml-6">
          {STEPS.map((s, i) => (
            <motion.li
              key={s.t}
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`process-step-${i + 1}`}
              className="relative pl-10"
            >
              <span className="absolute -left-[13px] top-0 grid h-6 w-6 place-items-center rounded-full border border-hydro-cyan/60 bg-hydro-cyan/10 font-mono text-[10px] font-bold text-hydro-cyan">
                {i + 1}
              </span>
              <h3 className="font-display text-lg font-bold text-white md:text-xl">{s.t}</h3>
              <p className="mt-1 max-w-xl text-sm leading-relaxed text-white/55">{s.d}</p>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
